import React, { Component } from "react";
import "./ViewPhotoSamplePopup.scss";
import correctPhoto from "../../../assets/PhotographSample/correctPhoto.jpg";
import hatCovered from "../../../assets/PhotographSample/hat-covered.svg";
import sunGlass from "../../../assets/PhotographSample/sunglass-covered.svg";
import shadow from "../../../assets/PhotographSample/shadow-covered.svg";

import BottomPanel from "../../BottomPanel/BottomPanel";
export interface IViewPhotoSamplePopupProps {
  setShowPopup: Function;
  showPopup: boolean;
  text?: any;
  children?: any;
}
const ViewPhotoSamplePopup = (props: IViewPhotoSamplePopupProps) => {
  const popupRef = React.useRef(null);
  React.useEffect(() => {
    const handleClickOutside = (event:any) => {
      if (popupRef.current!==null && popupRef.current!==undefined) {
        props?.setShowPopup(); // Close popup if clicked outside
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mousedown", handleClickOutside);
    }, 0);
    
    return () => {
      clearTimeout(timer);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [props?.setShowPopup]);
  return (
    <div className="overlay-main" ref={popupRef} >
      <div className="popup-main">
        {/* Close Button */}
        <button
          className="close-btn"
          onClick={(e) => {
            if (props?.setShowPopup !== undefined) props?.setShowPopup(false);
          }}
        >
          <i className="edel-icon-close" />
        </button>

        <h2 className="popup-title">Guide for Photo Upload</h2>

        {/* Popup Content */}
        {/* {commonUIView()} */}
        <div className="grid">
          <div className="box">
            <div className="profile-container">
              <img src={correctPhoto} alt="Profile" className="profile-image" />
              <div className="checkmark">✔</div>
            </div>
            <p className="success">
              Take a selfie facing the camera with a clear background.
            </p>
          </div>

          <div className="box">
            <img src={hatCovered} alt="hat covered" height={80} width={120} />
            <p className="error"> Don’t wear a hat.</p>
          </div>

          <div className="box">
            <img src={sunGlass} alt="sun glass" height={80} width={120} />
            <p className="error"> Don’t wear sunglasses. </p>
          </div>

          <div className="box">
            <img src={shadow} alt="Thick Stroke" height={80} width={120} />
            <p className="error"> Don’t click a dark and blurry photo.</p>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewPhotoSamplePopup;
